import { render, staticRenderFns } from "./pcshiyan.vue?vue&type=template&id=be07758e"
import script from "./pcshiyan.vue?vue&type=script&lang=js"
export * from "./pcshiyan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports